import { useForm } from '@/features/settings/components/PrinterConfiguration/form'
import { Form as FormValues } from '@/features/settings/components/PrinterConfiguration/form/types'
import { FC, ReactNode } from 'react'
import { FormProvider } from 'react-hook-form'

interface FormProps {
    children: ReactNode
    initialFormValues: Partial<FormValues>
}

const Form: FC<FormProps> = ({ children, initialFormValues }) => {
    const methods = useForm(initialFormValues)

    return <FormProvider {...methods}>{children}</FormProvider>
}

export default Form
